var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"x_btn",on:{"click":_vm.hideModal}},[_c('img',{attrs:{"src":require('@/assets/x_btn.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }